import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';

// Lazy load pages for better performance
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Users = lazy(() => import('../pages/Users'));
const Proctors = lazy(() => import('../pages/Proctors'));
const Tests = lazy(() => import('../pages/Tests'));
const Settings = lazy(() => import('../pages/Settings'));

// Loading component
const Loading = () => (
  <View as="div" textAlign="center">
    <Spinner renderTitle="Loading" size="large" />
  </View>
);

const AdminRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/proctors" element={<Proctors />} />
        <Route path="/tests" element={<Tests />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AdminRoutes;
